"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventLogFilter = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const dateTime_1 = require("../../../../utils/dateTime");
const Button_1 = require("../../../Button");
const Field_1 = require("../../../Form/Field");
const Date_1 = require("../../../Form/Field/Date");
const BadgeMultiSelect_1 = require("../../../Form/Field/MultiSelect/BadgeMultiSelect");
const legacy_1 = require("../../../Form/Field/Select/legacy");
const Icon_1 = require("../../../Icon");
const entityTypes_1 = require("../../entityTypes");
const operationTypes_1 = require("../../operationTypes");
const messages_1 = require("./messages");
require("./index.scss");
const className = 'event-log-filter';
const EventLogFilter = (props) => {
    var _a, _b, _c;
    const { data = {}, entityTypeItems = [], operationTypeItems: operationTypeItemsRaw = [], isShowSubmit = true, isShowReset = false, onChangeSearch = () => { }, onChangeFromDate = () => { }, onChangeToDate = () => { }, onChangeEntityType, onChangeOperationType = () => { }, onSubmit = () => { }, onReset = () => { }, } = props;
    const operationTypeItems = (0, react_1.useMemo)(() => [{ name: '', value: '' }, ...operationTypeItemsRaw.map((item) => {
            var _a;
            return { name: (_a = operationTypes_1.operationTypes[item]) !== null && _a !== void 0 ? _a : item, value: item };
        })], [operationTypeItemsRaw]);
    const handleChangeSearch = (0, react_1.useCallback)((event) => {
        onChangeSearch && onChangeSearch(event.target.value);
    }, [onChangeSearch]);
    const handleChangeFromDate = (0, react_1.useCallback)((newDate) => {
        onChangeFromDate && onChangeFromDate(newDate);
    }, [onChangeFromDate]);
    const handleChangeToDate = (0, react_1.useCallback)((newDate) => {
        onChangeToDate && onChangeToDate(newDate);
    }, [onChangeToDate]);
    const handleChangeOperationType = (0, react_1.useCallback)((event) => {
        onChangeOperationType && onChangeOperationType(event.target.value);
    }, [onChangeOperationType]);
    const intl = (0, react_intl_1.useIntl)();
    return (react_1.default.createElement("div", { className: className },
        react_1.default.createElement("div", { className: `${className}__form` },
            react_1.default.createElement("div", { className: `${className}__icon` },
                react_1.default.createElement(Icon_1.Icon, { name: 'search' })),
            react_1.default.createElement("div", { className: `${className}__search` },
                react_1.default.createElement(Field_1.FormField, { modificators: ['search'], placeholder: intl.formatMessage(messages_1.messages.searchPlaceholder), onChange: handleChangeSearch, value: data.search })),
            isShowSubmit && (react_1.default.createElement("div", { className: `${className}__button` },
                react_1.default.createElement(Button_1.Button, { text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/Form:SearchButton', defaultMessage: 'Search' }), modificators: ['ascetic', 'block'], onClick: onSubmit })))),
        react_1.default.createElement("div", { className: `${className}__filters` },
            react_1.default.createElement("div", { className: `${className}__filters-container` },
                react_1.default.createElement("div", { className: `${className}__dates` },
                    react_1.default.createElement("div", { className: 'form-fields-together' },
                        react_1.default.createElement(Date_1.FormFieldDate, { autoComplete: 'off', label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/Form:From', defaultMessage: 'From' }), name: 'fromDate', value: (_a = data.fromDate) !== null && _a !== void 0 ? _a : '', setValue: handleChangeFromDate, restrictions: {
                                pastYearsCount: dateTime_1.bookingFilterPastYearsCount,
                                nextYearsCount: dateTime_1.bookingNextYearsCount,
                            } }),
                        react_1.default.createElement(Date_1.FormFieldDate, { autoComplete: 'off', label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/Form:To', defaultMessage: 'To' }), name: 'toDate', value: (_b = data.toDate) !== null && _b !== void 0 ? _b : '', setValue: handleChangeToDate, restrictions: {
                                pastYearsCount: dateTime_1.bookingFilterPastYearsCount,
                                nextYearsCount: dateTime_1.bookingNextYearsCount,
                            } }))),
                react_1.default.createElement(BadgeMultiSelect_1.BadgeMultiSelect, { value: data.entityType, setValue: onChangeEntityType, items: entityTypeItems, toItem: entityTypes_1.mapEntityTypeToBadgeMultiSelectItem, label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/Form:Type', defaultMessage: 'Type' }), additionClassNames: `${className}__type` }),
                react_1.default.createElement("div", { className: `${className}__operation` },
                    react_1.default.createElement(legacy_1.LegacyFormFieldSelect, { onChange: handleChangeOperationType, items: operationTypeItems, value: (_c = data.operationType) !== null && _c !== void 0 ? _c : '', label: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/Form:Operation', defaultMessage: 'Operation' }) }))),
            isShowReset && (react_1.default.createElement("div", { className: `${className}__reset` },
                react_1.default.createElement(Button_1.Button, { icon: 'cycle', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/EntityLog/Form:ResetButton', defaultMessage: 'Reset' }), onClick: onReset, modificators: ['ascetic', 'simple'] }))))));
};
exports.EventLogFilter = EventLogFilter;
//# sourceMappingURL=index.js.map